import styled from 'styled-components'
import Button from 'react-bootstrap/Button'

export const AccountManagerContainer = styled.div`
    margin: 80px;
    text-align: center
`

export const StyledButton = styled(Button)`
    margin: 15px 5px;
`

export const FacebookNotice = styled.p`
    position: absolute;
    bottom: 10px;
    color: #DDD;
    margin: 5px;
    left: 0;
    right: 0;
`
